import styled from 'styled-components';

import { PADDING_CONTENT_PAGE, COLOR_ERROR, BACKGROUND_ERROR } from '../../../globals';


export const StyledCaptcha = styled.div`
  padding: 0px ${PADDING_CONTENT_PAGE}px 0px ${PADDING_CONTENT_PAGE}px;
  margin-bottom: 15px;
  width: 100%;

  .captcha--error-message {
    color: ${COLOR_ERROR};
    font-weight: bold;
    background: ${BACKGROUND_ERROR};
  }
`;
